function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_13921_323829)"
}, React.createElement("path", {
  d: "M3.33334 5.83333H16.6667",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M8.33334 9.16667V14.1667",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M11.6667 9.16667V14.1667",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M4.16666 5.83333L4.99999 15.8333C4.99999 16.2754 5.17558 16.6993 5.48815 17.0118C5.80071 17.3244 6.22463 17.5 6.66666 17.5H13.3333C13.7754 17.5 14.1993 17.3244 14.5118 17.0118C14.8244 16.6993 15 16.2754 15 15.8333L15.8333 5.83333",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333",
  stroke: "white",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_13921_323829"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgIconRemoveDark = function SvgIconRemoveDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconRemoveDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_remove_dark.1920c125.svg";
export { ForwardRef as ReactComponent };